import { render, staticRenderFns } from "./SettingsDelivery.vue?vue&type=template&id=3089fbca&"
import script from "./SettingsDelivery.vue?vue&type=script&lang=js&"
export * from "./SettingsDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports